// Initializes the buttons with data attributes and sets up event listeners.
const setupAQSButtons = () => {
  // Get all the buttons with data attributes that haven't been updated yet
  const aqsButtons = document.querySelectorAll('[data-aqs][data-box]:not([data-aqsran])');
  aqsButtons.forEach((button) => {
    const aqsBrand = button.dataset.name;
    const aqsSlug = button.dataset.slug;
    const aqsType = button.dataset.aqs;
    const aqsTech = button.dataset.localfibertype ?? '';
    const userType = button.dataset.type ?? 'Residential';
    const lsData = localStorage.getItem('mapi');
    const mapiRequestId = JSON.parse(lsData).requestId;

    let aqsTuneElement = document.querySelector(`.aqs_tune[data-provider="${aqsSlug}"]`);

    // empty tune link doesn't exist, need to create it
    if (!aqsTuneElement) {
      aqsTuneElement = document.createElement('a');
      aqsTuneElement.classList.add('aqs_tune');
      aqsTuneElement.classList.add('hidden');
      aqsTuneElement.dataset.provider = aqsSlug;
      aqsTuneElement.dataset.brand = aqsBrand;
      aqsTuneElement.href = button.href;
      // append the tune link after the button
      button.parentNode.appendChild(aqsTuneElement)
    }

    //  moves the normal link to aqs tune link if it doesn't exist
    if (aqsTuneElement && !aqsTuneElement.href) {
      aqsTuneElement.href = button.href;
    }

    // change all links to javascript:; if they have the same slug so they trigger the lightbox
    document.querySelectorAll(`a[data-slug="${aqsSlug}"][data-aqs]`).forEach((el) => {
      el.href = 'javascript:;';
    });

    button.dataset.aqsran = true;

    // Adjusts the lightbox values when the button is clicked.
    button.addEventListener('click', function () {
      const aqsTune = aqsTuneElement ? aqsTuneElement.href : '';

      if (aqsType == 'localfiber') {
        document.querySelector('.aqs-or-get').classList.add('hidden');
      } else {
        document.querySelector('.aqs-or-get').classList.remove('hidden');
      }

      // Sets the value of .aqs_provider_name to aqsBrand.
      document.querySelectorAll('.aqs_qual .aqs_provider_name').forEach(
        (el) => {
          el.innerHTML = aqsBrand;
        });
        
      // Sets the values of hidden inputs in the form.
      document.querySelector('.aqs_form input[name="provider"]').value = aqsBrand;
      document.querySelector('.aqs_form input[name="aqs_tune"]').value = aqsTune;
      document.querySelector('.aqs_form input[name="aqs_type"]').value = aqsType;
      document.querySelector('.aqs_form input[name="aqs_tech"]').value = aqsTech;
      document.querySelector('.aqs_form input[name="user_type"]').value = userType;
      document.querySelector('.aqs_form input[name="mapi_session_id"]').value = mapiRequestId;
    });
  });
}

export default setupAQSButtons;
